import classNames from 'classnames';
import { IconWithText } from 'common/icon/icon-with-text.js';
import { IconNameV1 } from 'common/icon/iconV1.js';
import { Tile } from 'common/tile/tile.js';
import { IModule } from 'redux-state/layout/types.js';
import { getAccessStatus } from 'utilities/status/state-access.js';
import { StatusAccess } from 'utilities/status/status-access.js';

export interface ISkiConditions {
  title: string;
  items: IItem[];
}

interface IItem {
  icon: IconNameV1;
  title: string;
  text: string;
  smallText?: string;
  status: StatusAccess;
}

export const SkiConditions = ({ config }: IModule<ISkiConditions>) => {
  const { items } = config;

  return (
    <Tile dataModule="ski-conditions" config={config}>
      <div className="Tile-body">
        <div className="SkiConditions">
          {items.map((item, index) => {
            const { icon, title, text, smallText } = item;
            const status = getAccessStatus(item.status === undefined ? StatusAccess.Default : item.status);

            return (
              <div className="SkiConditions-item" key={index}>
                <IconWithText
                  icon={icon}
                  classes={classNames('IconWithText--vCenter svg-fill-textSlate', {
                    isLast: index === items.length - 1,
                  })}
                >
                  <h4 className={'u-mT-0 u-mB-0'}>{title}</h4>
                  <p className="u-mT-0 u-mB-0">
                    <span className={`h1 u-textRegular ${status.textClass}`}>{text}</span>
                    {smallText && <span className="small">{smallText}</span>}
                  </p>
                </IconWithText>
              </div>
            );
          })}
        </div>
      </div>
    </Tile>
  );
};
